/**
 * A placeholder for a page the Phase 5 port has not reached.
 *
 * It exists so an unported route reads as "not built yet" rather than as a routing bug. The
 * Next.js app remains the working product until this one replaces it, and saying so on screen
 * is more useful than a blank page or a 404.
 */

import { Alert, AlertTitle, Box, Typography } from "@mui/material";

export function NotBuiltYet({ page }: { page: string }) {
  return (
    <Box className="mx-auto max-w-md py-12">
      <Alert severity="info" variant="outlined" sx={{ backgroundColor: "rgba(255,255,255,0.9)" }}>
        <AlertTitle>{page} is not built yet</AlertTitle>
        <Typography variant="body2">
          This page has not been ported from the Next.js app yet. Use the existing app for it in
          the meantime.
        </Typography>
      </Alert>
    </Box>
  );
}
